import type { NavItem } from "./adminNav";

/** Drop entries whose required feature flag is not on, at every depth. */
export function filterNavByFeatureFlags(
  items: NavItem[],
  flags: Partial<Record<string, boolean>> = {},
): NavItem[] {
  return items
    .filter(
      (item) =>
        !item.requiredFeatureFlag || flags[item.requiredFeatureFlag] === true,
    )
    .map((item) =>
      item.children
        ? { ...item, children: filterNavByFeatureFlags(item.children, flags) }
        : item,
    );
}
